export const CREATE_TEAM_LOOKUP = "CREATE_TEAM_LOOKUP"
export const CREATE_TEAM_LOOKUP_SUCCESS = "CREATE_TEAM_LOOKUP_SUCCESS"
export const CREATE_TEAM_LOOKUP_ERROR = "CREATE_TEAM_LOOKUP_ERROR"

// Create Team Data for Datatable
export const CREATE_TEAM = "CREATE_TEAM"
export const CREATE_TEAM_SUCCESS = "CREATE_TEAM_SUCCESS"
export const CREATE_TEAM_ERROR = "CREATE_TEAM_ERROR"

// get Team Data for Datatable
export const GET_TEAMS = "GET_TEAMS"
export const GET_TEAMS_SUCCESS = "GET_TEAMS_SUCCESS"
export const GET_TEAMS_ERROR = "GET_TEAMS_ERROR"

// approve teams
export const APPROVE_TEAM = "APPROVE_TEAM"
export const APPROVE_TEAM_SUCCESS = "APPROVE_TEAM_SUCCESS"
export const APPROVE_TEAM_ERROR = "APPROVE_TEAM_ERROR"

// reject team
export const REJECT_TEAM = "REJECT_TEAM"
export const REJECT_TEAM_SUCCESS = "REJECT_TEAM_SUCCESS"
export const REJECT_TEAM_ERROR = "REJECT_TEAM_ERROR"

// end teams
export const END_TEAM = "END_TEAM"
export const END_TEAM_SUCCESS = "END_TEAM_SUCCESS"
export const END_TEAM_ERROR = "END_TEAM_ERROR"

// update team
export const UPDATE_TEAMS = "UPDATE_TEAMS"
export const UPDATE_TEAMS_SUCCESS = "UPDATE_TEAMS_SUCCESS"
export const UPDATE_TEAMS_ERROR = "UPDATE_TEAMS_ERROR"

// company detail
export const GET_COMPANY_DETAIL = "GET_COMPANY_DETAIL"
export const GET_COMPANY_DETAIL_SUCCESS = "GET_COMPANY_DETAIL_SUCCESS"
export const GET_COMPANY_DETAIL_ERROR = "GET_COMPANY_DETAIL_ERROR"

export const COMPANY_DETAIL = "COMPANY_DETAIL"
export const COMPANY_DETAIL_SUCCESS = "COMPANY_DETAIL_SUCCESS"
export const COMPANY_DETAIL_ERROR = "COMPANY_DETAIL_ERROR"
// project Team Data
export const GET_PROJECT_TEAMS = "GET_PROJECT_TEAMS"
export const GET_PROJECT_TEAMS_SUCCESS = "GET_PROJECT_TEAMS_SUCCESS"
export const GET_PROJECT_TEAMS_ERROR = "GET_PROJECT_TEAMS_ERROR"

// update team
export const UPDATE_TEAMS_NO_APPROVED = "UPDATE_TEAMS_NO_APPROVED"
export const UPDATE_TEAMS_NO_APPROVED_SUCCESS = "UPDATE_TEAMS_NO_APPROVED_SUCCESS"
export const UPDATE_TEAMS_NO_APPROVED_ERROR = "UPDATE_TEAMS_NO_APPROVED_ERROR"

// upload application 
export const UPLOAD_APPLICATION = "UPLOAD_APPLICATION"
export const UPLOAD_APPLICATION_SUCCESS = "UPLOAD_APPLICATION_SUCCESS"
export const UPLOAD_APPLICATION_ERROR = "UPLOAD_APPLICATION_ERROR"

// category data
export const GET_CATEGORY_USER = "GET_CATEGORY_USER"
export const GET_CATEGORY_USER_SUCCESS = "GET_CATEGORY_USER_SUCCESS"
export const GET_CATEGORY_USER_ERROR = "GET_CATEGORY_USER_ERROR"

